import { createStore, applyMiddleware, Middleware } from 'redux';
import thunkMiddleware from 'redux-thunk';
import rootReducer from '../reducers';
import { composeWithDevTools } from 'redux-devtools-extension';

const middlewares: Middleware[] = [thunkMiddleware as unknown as Middleware];

if (process.env.NODE_ENV === 'development' && typeof window !== 'undefined') {
  const { createLogger } = require('redux-logger');
  middlewares.push(createLogger() as Middleware);
}

const store = createStore(
  rootReducer,
  composeWithDevTools(applyMiddleware(...middlewares))
);

export type AppState = ReturnType<typeof rootReducer>;
export default store;